import * as _ from 'lodash';
import moment from 'moment';
import { convertavailabilityTocertainTimeZone } from '../../../../HelperMethods/AssetFormUtilities';
// eslint-disable-next-line import/no-cycle
import SCHEMA_CONSTANTS from '../schemaConstants';

export const attachmentMerge = (asset, attachment) => {
  const Attachments = _.cloneDeep(asset.attachments) || [];
  const attachmentList = [];
  if (Attachments && !_.isEmpty(Attachments)) {
    Attachments.forEach((attachmentObj, index) => {
      if (_.isString(attachmentObj) && !_.isObject(attachmentObj)) {
        const filteredAttachment = attachment.filter((attachmentListObj) => attachmentListObj.key === attachmentObj);
        if (!_.isEmpty(filteredAttachment)) {
          const finalAttachmentObj = filteredAttachment[0];
          Attachments[index] = {
            bucket: finalAttachmentObj.bucket,
            key: finalAttachmentObj.key,
            region: finalAttachmentObj.region,
            fileName: finalAttachmentObj.fileName,
          };
        }
      } else {
        attachmentList.push(attachmentObj);
      }
    });
  }
  return Attachments;
};

export const geofencedestructor = (clonedParts) => {
  const { type, radius, polygon } = clonedParts;
  const returnObj = {};
  const coordinatesfromAsset = [];
  returnObj.radius = radius;
  returnObj.type = type;
  polygon.forEach((coordinate) => {
    const latitude =
      coordinate[0] && typeof coordinate[0] === 'number' ? JSON.stringify(coordinate[1]) : coordinate[1] || '';
    const longitude =
      coordinate[0] && typeof coordinate[1] === 'number' ? JSON.stringify(coordinate[0]) : coordinate[0] || '';
    coordinatesfromAsset.push({ latitude, longitude });
  });
  returnObj.polygon = coordinatesfromAsset;
  return returnObj;
};

export const geofenceMapper = (polygonArea) => {
  const returnPolygonArea = {};
  const tempPolygonArea = _.cloneDeep(polygonArea);

  const fiterePolygonAreaCoordinates = tempPolygonArea.polygon.filter(
    (coordinate) => coordinate.latitude && coordinate.longitude
  );
  tempPolygonArea.polygon = fiterePolygonAreaCoordinates;
  if (!_.isEmpty(tempPolygonArea.radius) && tempPolygonArea.radius !== '0') {
    returnPolygonArea.type = 'radial';
    returnPolygonArea.radius = _.isString(tempPolygonArea.radius)
      ? JSON.parse(tempPolygonArea.radius)
      : tempPolygonArea.radius;
    returnPolygonArea.polygon = [];
  } else if (_.isEmpty(tempPolygonArea.radius) && tempPolygonArea.polygon && tempPolygonArea.polygon.length > 2) {
    returnPolygonArea.type = 'polygon';
    returnPolygonArea.radius = '';
    const polygonCoordinateArray = [];
    tempPolygonArea.polygon.forEach((coordinate) => {
      let stringStatelatitude = false;
      let stringStatelongitude = false;
      if (_.isString(coordinate.latitude)) {
        stringStatelatitude = true;
      }
      if (_.isString(coordinate.longitude)) {
        stringStatelongitude = true;
      }
      const longitude = stringStatelatitude ? JSON.parse(coordinate.longitude) : coordinate.longitude;
      const latitude = stringStatelongitude ? JSON.parse(coordinate.latitude) : coordinate.latitude;
      const pushArray = [longitude, latitude];
      polygonCoordinateArray.push(pushArray);
    });

    returnPolygonArea.polygon = polygonCoordinateArray;
  }

  return returnPolygonArea;
};

export function bulkEditToSaveObj(selectedUsers, formvalue) {
  const obj = selectedUsers;

  for (const [formKeys, formValues] of Object.entries(formvalue)) {
    if (formKeys !== 'name') {
      if (formKeys === 'availability') {
        const availability = formValues.filter(
          (availabilityobj) =>
            availabilityobj.availabilityStartTime &&
            availabilityobj.availabilityStartDate &&
            availabilityobj.availabilityEndTime &&
            availabilityobj.availabilityEndDate
        );
        if (!_.isEmpty(availability)) {
          obj.availability = convertavailabilityTocertainTimeZone(availability, 'America/Chicago');
        }
      }
    }
  }

  return obj;
}

export const assetFormtoObj = (finalAttributeObj, unfilterObj, isUpdate) => {
  const returnObj = isUpdate ? _.clone(unfilterObj) : {};
  // const isCreate = _.isEmpty(returnObj);

  // eslint-disable-next-line no-unused-vars
  for (const [ObjKeys, ObjValues] of Object.entries(SCHEMA_CONSTANTS)) {
    const { finalPath } = ObjValues;

    if (ObjKeys === 'att_attachements') {
      let presentAttachment = _.clone(returnObj[finalPath]) || [];

      if (finalAttributeObj[finalPath]) {
        presentAttachment = [...presentAttachment, ...finalAttributeObj[finalPath]];
      }

      returnObj[finalPath] = presentAttachment;
    }
    if (ObjKeys === 'global_attributes') {
      let customglobalAttribute = _.cloneDeep(returnObj[finalPath]);
      customglobalAttribute = { ...customglobalAttribute, ...finalAttributeObj[finalPath] };
      returnObj[finalPath] = customglobalAttribute;
    }
    if (ObjKeys === 'g_areas') {
      const areas = _.cloneDeep(returnObj[finalPath]);
      const areaArray = [];
      if (!_.isEmpty(areas)) {
        areas.forEach((areaObj) => {
          areaArray.push({ areaId: areaObj.areaId, isDeleted: areaObj.isDeleted });
        });
        returnObj[finalPath] = areaArray;
      }
    }
    // if (ObjKeys === 'g_field') {
    //   returnObj[finalPath] = finalAttributeObj[finalPath];
    //   if (!_.isEmpty(finalAttributeObj.fieldId)) returnObj.field = { id: finalAttributeObj[finalPath] };
    // }
    // if (ObjKeys === 'g_stop') {
    //   returnObj[finalPath] = finalAttributeObj[finalPath];
    //   if (!_.isEmpty(finalAttributeObj.stopId)) returnObj.stop = { id: finalAttributeObj[finalPath] };
    // }
    if (ObjKeys === 'g_field' && !isUpdate && !_.isEmpty(finalAttributeObj[finalPath])) {
      returnObj[finalPath] = finalAttributeObj[finalPath];
      if (!_.isEmpty(finalAttributeObj.fieldId)) returnObj.field = { id: finalAttributeObj[finalPath] };
    }
    if (ObjKeys === 'g_stop' && !isUpdate && !_.isEmpty(finalAttributeObj[finalPath])) {
      returnObj[finalPath] = finalAttributeObj[finalPath];
      if (!_.isEmpty(finalAttributeObj.stopId)) returnObj.stop = { id: finalAttributeObj[finalPath] };
    }
    if (finalAttributeObj[finalPath] && ObjKeys !== 'att_attachements' && ObjKeys !== 'global_attributes') {
      returnObj[finalPath] = finalAttributeObj[finalPath];
    }
  }

  return isUpdate ? returnObj : _.omit(returnObj, ['stopId', 'fieldId']);
};

export const deleteAssetMapper = (asset) => {
  const returnObj = _.cloneDeep(asset);
  const areasList = [];
  if (returnObj.areas && !_.isEmpty(returnObj.areas)) {
    returnObj.areas.forEach((areasObj) => {
      areasList.push({ areaId: areasObj.areaId, isDeleted: areasObj.isDeleted });
    });
    returnObj.areas = areasList;
  }
  returnObj.isDeleted = true;

  return returnObj;
};

export const mapErrorToField = ({ formValues }) => {
  const error = [];
  const tempAvailibility = _.get(formValues, 'availability_availability', []);

  if (
    (tempAvailibility.length === 1 &&
      _.isEmpty(tempAvailibility[0].availabilityEndDate) &&
      _.isEmpty(tempAvailibility[0].availabilityEndTime) &&
      _.isEmpty(tempAvailibility[0].availabilityStartDate) &&
      _.isEmpty(tempAvailibility[0].availabilityStartTime)) ||
    tempAvailibility.length === 0
  ) {
    return { isValid: true };
  }

  const filteredAvailibility = tempAvailibility.filter(
    (availabilityList) =>
      availabilityList.availabilityEndDate &&
      availabilityList.availabilityEndTime &&
      availabilityList.availabilityStartDate &&
      availabilityList.availabilityStartTime
  );

  if (filteredAvailibility.length === 0) {
    const errorMessage = { error: 'Some Fields are missing' };
    error[0] = errorMessage;
    return { isValid: false, error };
  }

  const availability = convertavailabilityTocertainTimeZone(filteredAvailibility, 'America/Chicago');

  availability.forEach((availabilityList, index) => {
    const errObj = {};
    const startYear = moment(availabilityList.startDate).year();
    const endYear = moment(availabilityList.endDate).year();

    if (startYear !== endYear) {
      errObj.error = 'Availability Period should be within a year';
    } else if (moment(availabilityList.startDate).isSameOrAfter(moment(availabilityList.endDate))) {
      errObj.error = 'Start Date greater than end Date';
    } else if (moment(availabilityList.startTime).isSameOrAfter(moment(availabilityList.endTime))) {
      errObj.error = 'Start Time greater than Equals End Time';
    }

    if (Object.keys(errObj).length !== 0) {
      error[index] = errObj;
    }
  });

  return { isValid: error.length === 0, error };
};

export default mapErrorToField;
